import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthServiceService } from "../../shareModule/services/auth-service.service";
import { ApiResponse } from "src/app/shareModule/models/common.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ImageModalComponent } from "src/app/shareModule/component/chat/chatbot/image-modal.component";
import { environment } from "src/environments/environment";
import { BusinessService } from "src/app/business/business.service";
import { CommonService } from "src/app/shareModule/services/common.service";

@Component({
  selector: "app-super-admin",
  templateUrl: "./super-admin.component.html",
  styleUrls: ["./super-admin.component.scss"],
})
export class SuperAdminComponent implements OnInit {
  public imgUrl = environment.ImageUrl;
  public allSuggestions: Array<any> = [];
  public allReports: Array<any> = [];
  public allBizReq: Array<any> = [];
  public rentProduct: Array<any> = [];
  public selMenu = "suggestion";
  public subMenuChat: "all" | "unseen" = "unseen";
  public allChatReports: Array<any> = [];
  public activeChatReports: Array<any> = [];
  public imageUrl: string = "";
  public commonModal: any = null;
  public form: FormGroup = new FormGroup({
    id: new FormControl(""),
    name: new FormControl("", [Validators.required]),
    description: new FormControl("", [Validators.required]),
    price: new FormControl("", [Validators.required]),
    type: new FormControl("rent"),
    // image: new FormControl(""),
  });

  /**
   * Constructor
   */
  constructor(
    public commonService: CommonService,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private businessService: BusinessService
  ) {
    this.imageUrl = environment.ImageUrl;
    this.getBadWords();
  }

  getBadWords() {
    this.auth.get_bad_words().subscribe((data: any) => {
      this.chatBadWords = data.data;
    });
  }

  chatBadWords: any[] = [];

  bannedWordToBeAdded: string = "";

  removeBannedWord = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLElement;

    //console.log(Array.from(target.attributes), target);
    const word = target.getAttribute("wordcontent");
    this.auth.remove_bad_word(word).subscribe(
      (data) => {
        this.toastr.show("Word Removed");
        this.getBadWords();
      },
      (err) => {
        this.toastr.error("Error while Removing banned word");
        console.error(err);
      }
    );
  };

  submitBadWord = () => {
    if (!this.bannedWordToBeAdded) {
      return;
    }
    this.auth.add_bad_word(this.bannedWordToBeAdded).subscribe(
      (data) => {
        this.toastr.show("Banned word added");
        this.getBadWords();
        this.bannedWordToBeAdded = "";
      },
      (err) => {
        this.toastr.error("Error while adding banned word");
        console.error(err);
        this.bannedWordToBeAdded = "";
      }
    );
  };

  showImage(src) {
    this.modalService.dismissAll();
    const ref = this.modalService.open(ImageModalComponent, {
      size: "sm",
      windowClass: "image-modal",
    });
    ref.componentInstance.imageSrc = environment.ImageUrl + src;
  }

  ngOnInit(): void {
    this._getAllSuggestions();
    this._getAllReports();
    this._fetchChatReports();
    this._getAllBizRequest();
    this.getAllRentProduct();
  }

  public selectMenuChat(subMenu: "all" | "unseen") {
    this.subMenuChat = subMenu;
    this._filterChatReports();
  }
  public selectMenu(menu: string) {
    this.selMenu = menu;
    this._filterChatReports();
  }
  private _filterChatReports() {
    if (this.subMenuChat === "all") {
      this.activeChatReports = this.allChatReports;
    } else {
      this.activeChatReports = Array.from(this.allChatReports.filter((x) => !x.isResolved));
    }
  }
  private _getAllSuggestions(): void {
    this.auth.getAllSuggestions().subscribe((response: ApiResponse) => {
      this.allSuggestions = response?.body || [];
    });
  }

  public resolveChatReportClickHandler(e: Event): void {
    const target = e.currentTarget as HTMLElement;
    const reporterId = target.getAttribute("reportId");

    this.auth.ack_report(reporterId).subscribe(
      (data) => {
        this.toastr.success("Successfuly resolved");
        this._fetchChatReports();
      },
      (err) => {
        console.error(err);
        this.toastr.error("Error while invalidating report");
      }
    );
  }
  private _fetchChatReports(): void {
    this.auth.get_chat_reports().subscribe((data: any) => {
      this.allChatReports = data?.data;
      console.log("chat reports = ", this.allChatReports);
      this._filterChatReports();
    });
  }

  private _getAllReports(): void {
    this.auth.getAllReports().subscribe((response: ApiResponse) => {
      this.allReports = response?.body || [];
      console.log("ALL REPORTS", this.allReports);
    });
  }

  private _getAllBizRequest(): void {
    this.businessService.getAllBiz().subscribe((response: ApiResponse) => {
      this.allBizReq = response?.body || [];
    });
  }

  viewReportDetail(report: any) {
    if (report.category == "product") {
      window.open(`${window.location.origin}/community/${report.member_product_id}`, "_blank");
    } else if (report.category == "biz_product") {
      window.open(`${window.location.origin}/biz/${report.product_id}`, "_blank");
    }
  }

  public selectedCategory: any;
  public imageBase64: string | ArrayBuffer;
  public categoryImage: string = "";

  public saveProductCharSelectedImage(event) {
    this.selectedCategory ? (this.selectedCategory.image = null) : "";
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.categoryImage = file;
    };
    fileReader.readAsDataURL(file);
  }

  public edit(modal: any, selected: any = null) {
    if (selected) {
      this.form.patchValue({
        id: selected?.id,
        name: selected?.name,
        description: selected?.description,
        price: selected?.price,
        type: selected?.type,
      });
      this.selectedCategory = selected;
      this.categoryImage = selected?.image;
    } else {
      this.selectedCategory = null;
      this.form.reset();
    }

    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public addProduct(modal: any) {
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public AddEditCategorySubmit() {
    let formData = new FormData();
    typeof this.categoryImage == "string" ? "" : formData.append("image", this.categoryImage);
    formData.append("id", this.form.get("id").value);
    formData.append("name", this.form.get("name").value);
    formData.append("description", this.form.get("description").value);
    formData.append("price", this.form.get("price").value);
    formData.append("type", this.form.get("type").value);

    this.auth.addRentProducts(formData).subscribe(
      (resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal ? this.commonModal.close() : "";
        this.getAllRentProduct();
        this.form.reset();
        this.categoryImage = "";
        this.selectedCategory = null;
        this.imageBase64 = null;
      },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
  }

  private getAllRentProduct(): void {
    this.auth.getAllRentProdut().subscribe((response: ApiResponse) => {
      this.rentProduct = response?.body || [];
    });
  }

  public removeRentProduct(id) {
    this.auth.deleteRentProdut(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getAllRentProduct();
    })
  }

}
